export function clearGridLocalStorage() {
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    if (key.startsWith('grid')) {
      localStorage.removeItem(key);
    }
  });
  console.log('All grid-related localStorage keys have been cleared.');
}
